export default __webpack_public_path__ + "e68e6047ee7f10c8ac196701c1d36650.png";